// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"471":"88ce2c5a","633":"88ce2c5a","909":"73f8f144"}[chunkId] + ".chunk.css";
};